/**
 * NotFoundPage — fallback route for unmatched URLs.
 * Keeps the chrome (top bar + sidebar) so the user can navigate away.
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <div className="text-aurora text-7xl font-extrabold leading-none">404</div>
      <div className="text-base text-fg-dim">That page is not on the rack.</div>
      <Button asChild>
        <Link to="/">Back to overview</Link>
      </Button>
    </div>
  );
}
